import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EPSpotlightCategory = ({
  category,
  children
}) => {
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    marginBlockStart: "400",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-25",
      paddingInline: "400",
      paddingBlockEnd: "200",
      children: category
    }), /*#__PURE__*/_jsx(View, {
      as: "ul",
      paddingInline: "0",
      children: children
    })]
  });
};
export default EPSpotlightCategory;